import React from 'react'

import { Link } from 'gatsby'

import { Layout, Header, Intro } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/develop/'}
        site={data.site}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>Details for contributing to our ADO repositories coming soon!</p>
          <p>
            For light contribution like bug reports and feature requests, visit{' '}
            <Link className="link" to={'/mt/general/reporting/develop'}>
              Bug Reporting and Requests
            </Link>
            .
          </p>
        </Intro>
      </Layout>
    </>
  )
}
